// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__IFcDD","forgot":"LoginForm_forgot__jd1vu","register":"LoginForm_register__M9YeM","subtitle":"LoginForm_subtitle__G6qwD"};